// 端外投放落地页 - 秒杀
// 状态：pv，uv几乎接近于0，推测处于下线状态
export default {
  routes: [
    {
      path: '/(\\s*)bargainrushed(\\d*)/(\\s*)index(\\d*)',
      name: 'bargainrushedIndex',
      meta: {
        desc: '秒杀页'
      },
      component: () =>
        import(/* webpackChunkName: "bargainrushed" */ '../views/bargainrushed/index.vue')
    }
  ]
}
